import React from "react";
import { FormBox } from "./FormBox";
import { ShelfDrawer } from "./ShelfDrawer";
import { ShelfTable } from "./ShelfTable";

export default (props) => {
    return (
        <div className="yh-detail-box">
            <FormBox {...props} />
            <ShelfTable {...props} />
            <ShelfDrawer {...props} />
        </div>
    )
}